import AgTypography from '../../Styles/AgTypography';
import { CSSProperties, ReactNode } from 'react';
import { AgColor } from '../../Styles/AgColor';

export interface ProfileSectionTableData {
  name: string;
  value?: ReactNode;
  thirdValue?: ReactNode;
  isMissed?: boolean;
}

export interface ProfileSectionTableProps {
  tableData: ProfileSectionTableData[];
  style?: CSSProperties;
  title?: string;
  caption?: string;
}

const AgSimpleTable = (
  {
    tableData,
    style,
    title,
    caption
  }: ProfileSectionTableProps
) => {
  return (
    <AgTypography
      style={{
        display: 'grid',
        gap: '16px',
        ...style
      }}
    >
      {title && <AgTypography contentStyle={'AP.H5.UPPERCASE.Bold'} message={title} style={{ color: AgColor.grey6 }} />}
      {caption && <AgTypography contentStyle={'AP.Paragraph.Small.Regular'} message={caption} style={{ color: AgColor.grey7 }} />}
      <AgTypography
        style={{
          display: 'grid',
          borderBottom: `1px solid ${AgColor.grey4}`,
          borderRight: `1px solid ${AgColor.grey4}`,
        }}
      >
        {tableData.map((item: ProfileSectionTableData, index: number) => {
          return (
            <AgTypography
              key={index}
              style={{
                display: 'flex',
                borderLeft: `1px solid ${AgColor.grey4}`,
                borderTop: `1px solid ${AgColor.grey4}`,
                minHeight: '40px'
              }}
            >
              <AgTypography
                contentStyle={'AP.H5.Bold'}
                style={{
                  width: '160px',
                  padding: '8px 24px',
                  borderRight: `1px solid ${AgColor.grey4}`,
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'hidden',
                  color: item.isMissed ? AgColor.errorMain : AgColor.grey8
                }}
              >
                {item.name}
              </AgTypography>
              <AgTypography
                contentStyle={'AP.Paragraph.Small.Regular'}
                style={{
                  flex: 1,
                  padding: '8px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'hidden',
                  color: item.isMissed ? AgColor.errorMain : AgColor.grey9
                }}
              >
                {item.value}
              </AgTypography>
              {item.thirdValue ? (
                <AgTypography
                  contentStyle={'AP.Paragraph.Small.Regular'}
                  style={{
                    flex: 1,
                    padding: '8px 24px',
                    display: 'flex',
                    borderLeft: `1px solid ${AgColor.grey4}`,
                    alignItems: 'center',
                    overflow: 'hidden',
                    color: item.isMissed ? AgColor.errorMain : AgColor.grey9
                  }}
                >
                  {item.thirdValue}
                </AgTypography>
              ) : null}
            </AgTypography>
          );
        })}
      </AgTypography>
    </AgTypography>
  );
};

export default AgSimpleTable;